module.exports = __webpack_public_path__ + "img/room-carousel-1.1407c94d.jpg";